import { FC, ReactNode } from 'react'
import { BrowserRouter } from 'react-router-dom'

interface RouterInterface {
  children: ReactNode
}

const Router: FC<RouterInterface> = ({ children }) => <BrowserRouter>{children}</BrowserRouter>

export default Router
